import { z } from 'zod';

export const FlagDebitNoteSchema = z.object({
  [typeof '']: z.string().optional(),
});

export type FlagDebitNoteForm = z.infer<typeof FlagDebitNoteSchema>;
